import PropTypes from "prop-types";
import { CARD_GRID, PLAYLIST, CAROUSEL, MIXED_CARD_LAYOUT } from "./constants";
import CardGrid from "./layouts/CardGrid/component";
import VideoPlaylist from "./layouts/VideoPlaylist/component";
import Carousel from "./layouts/Carousel/component";
import MixedCardLayout from "./layouts/MixedCardLayout/component";
/**
 * Layout is a factory that creates Layout components: CardGrid, ContentPackage, etc.
 * @param {Object}
 * name: the name of the layout that comes from Nine, it determines which layout to render
 * children: the card components to render in the layout
 * @returns {JSX.Element} The Layout component
 */
const LayoutFactory = ({
    layout,
    items,
    featureAttributionData = {},
    cardClickHandler = () => {},
    indexToFocus = null,
    startAt = 1,
}) => {
    if (!layout || !items?.length) return;

    switch (layout.name) {
        case CARD_GRID:
            return (
                <CardGrid
                    layout={layout}
                    items={items}
                    featureAttributionData={featureAttributionData}
                    cardClickHandler={cardClickHandler}
                    indexToFocus={indexToFocus}
                    startAt={startAt}
                />
            );
        case PLAYLIST:
            return (
                <VideoPlaylist
                    layout={layout}
                    items={items}
                    featureAttributionData={featureAttributionData}
                />
            );
        case CAROUSEL:
            return (
                <Carousel
                    layout={layout}
                    items={items}
                    featureAttributionData={featureAttributionData}
                />
            );
        case MIXED_CARD_LAYOUT:
            return (
                <MixedCardLayout
                    items={items}
                    featureAttributionData={featureAttributionData}
                    startAt={startAt}
                />
            );
        default:
            return null;
    }
};

/**
 * Helper function to get placeholder items that can be rendered during loading states
 * @param {string} numItems - The number of placeholder items
 * @param {string} variant - The layout variant, defaults to "standard"
 *
 * @returns {Object[]} An array of placeholder items
 */
export const getPlaceholderItems = (numItems, variant = "standard") => {
    const placeholders = [];
    for (let i = 0; i < numItems; i++) placeholders.push({ variant });
    return placeholders;
};

LayoutFactory.propTypes = {
    layout: PropTypes.object,
    items: PropTypes.arrayOf(PropTypes.object),
    featureAttributionData: PropTypes.object,
    cardClickHandler: PropTypes.func,
    indexToFocus: PropTypes.number,
};

export default LayoutFactory;
